// extracted by extract-css-chunks-webpack-plugin
module.exports = {"intro":"create-campaign-main__intro___22M0k","status-label":"create-campaign-main__status-label___Dryvs","statusLabel":"create-campaign-main__status-label___Dryvs"};
    if(module.hot) {
      // 1770059458594
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  